import Vue from "vue";
import _ from "underscore";

export default {
	login({commit, dispatch}, data) {
		return Vue.api.post('auth/login', data).then(response => {
			commit('setUser', response || {})

			if (response.workers.length) {
				commit('setWorker', response.workers[0] || {})

				dispatch('clinic/get', response.workers[0].clinic_id, {root: true}).then(response => {
					commit('setClinic', response || {})
				})
			}

			return response
		})
	},
	getUser({commit, dispatch}) {
		if (!Vue.storage.isExist('X-Access-Token')) {
			return false
		}

		return Vue.api.get('auth/on-reload').then(user => {
			commit('setUser', user || {})

			if (Vue.storage.isExist('worker')) {
				let worker_id = Vue.storage.get('worker')

				let worker = _(user.workers).findWhere({_id: worker_id})

				if (worker !== undefined) {
					commit('setWorker', worker)

					dispatch('clinic/get', worker.clinic_id, {root: true}).then(clinic => {
						commit('setClinic', clinic)
					})
				}
			}

			return user
		})
	},
	logout({commit}) {
		commit('clean')
		Vue.storage.clear()
	},
	checkUser({state}) {
		return state.logged = Vue.storage.isExist('X-Access-Token');
	}
}



// WEBPACK FOOTER //
// ./src/vuex/services/auth/actions.js